import GovFooterBar from './GovFooterBar';

export default GovFooterBar;